export const selectSupplierReducer = (state, action) => {
  state.selectedSupplier = action.payload;
};

export const selectCategoryReducer = (state, action) => {
  state.selectedCategory = action.payload;
};

export const selectProductReducer = (state, action) => {
  state.selectedProduct = action.payload;
};
